import React from "react";
import MediaQuery from "react-responsive";

export const Small = props => <MediaQuery {...props} maxWidth={420} />;
export const Big = props => <MediaQuery {...props} minWidth={421} />;
export const Mobile = props => <MediaQuery {...props} maxWidth={820} />;
export const Default = props => <MediaQuery {...props} minWidth={821} />;
